import React from "react"

export default () => {
  return (
    <svg
      width="143px"
      height="100px"
      viewBox="0 0 143 100"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="youtube">
        <path
          d="M127.186 3.05804C133.299 4.70562 138.119 9.52892 139.764 15.6476C142.821 26.8232 142.703 50.1177 142.703 50.1177C142.703 50.1177 142.703 73.2936 139.765 84.4701C138.119 90.5879 133.3 95.4112 127.186 97.0579C116.019 100 71.3521 100 71.3521 100C71.3521 100 26.8006 100 15.5168 96.9411C9.40328 95.2935 4.58493 90.4702 2.93874 84.3524C0 73.2936 0 50 0 50C0 50 0 26.8232 2.93874 15.6476C4.58318 9.52979 9.52086 4.58793 15.5159 2.9421C26.683 0 71.3503 0 71.3503 0C71.3503 0 116.019 0 127.186 3.05804ZM57.1287 28.5885L57.1287 71.4115L94.2732 50L57.1287 28.5885Z"
          id="Shape"
          fill="#000000"
          fillRule="evenodd"
          stroke="none"
        />
      </g>
    </svg>
  )
}
